import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  Input,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from 'ngx-markdown';

@Component({
  selector: 'app-html',
  templateUrl: './html.component.html',
  styleUrls: ['./html.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HtmlComponent implements OnInit {
  @Input()
  set html(input: string) {
    this.safeHTML = this.domSanitizer.bypassSecurityTrustHtml(input || '');
  }

  @Input()
  set markdownText(input: string) {
    this.html = this.markdownService.compile(input, true);
  }

  safeHTML: SafeHtml;

  constructor(private domSanitizer: DomSanitizer, private markdownService: MarkdownService) {}

  ngOnInit() {}
}
